var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-carousel',_vm._l((_vm.carousels),function(carousel,i){return _c('b-carousel-item',{key:i},[_c('figure',{staticClass:"image is-16by9"},[_c('img',{staticClass:"preview-image",attrs:{"src":carousel.image}})])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }